import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useParams } from 'react-router-dom';
import {
  Button,
  Modal,
  Separator,
  StepsIndicator,
  TermsAndConditions,
  Title
} from '../../../../components';
import { AppContext } from '../../../../context/AppContext';
import { useKeyPress, useNavigate, useResource } from '../../../../hooks';
import { ConstancyService } from '../../../../interfaces';

import './styles.scss';

export const Step4 = () => {
  const {
    updateResource
  } = useResource<ConstancyService>();

  const navigate = useNavigate();
  const params = useParams();

  const {
    apiType,
    setOpenModal,
    openModal,
    soundEffects
  } = useContext(AppContext);

  const { t } = useTranslation();

  const [checkedTermsAndConditions, setCheckedTermsAndConditions] = useState<boolean>(false);

  const updateConstancyService = () => {
    if (checkedTermsAndConditions) {
      updateResource(
        `/${apiType}/constancy-services/${params.constancyServiceID}`,
        {
          requestIsCompleted: true
        },
        () => {
          Modal.fireSuccess(
            t('global.correct'),
            t('services.requestSaved'),
            setOpenModal,
            () => navigate(`/constancy-services/detail/${params.constancyServiceID}/none`),
            soundEffects
          );
        },
        (error: string) => Modal.fireError(error, setOpenModal, soundEffects)
      );
    } else {
      Modal.fireError(t('services.errors.termsAndConditions'), setOpenModal, soundEffects);
    }
  };

  useKeyPress(
    openModal ? () => { } : () => updateConstancyService(),
    [checkedTermsAndConditions, openModal]
  );

  return (
    <div className='step-4-constancy'>
      <div className='step-4-constancy__steps'>
        {
          apiType === 'admin' ? (
            <StepsIndicator
              stepsQuantity={4}
              currentStep={4}
            />
          ) : (
            <StepsIndicator
              stepsQuantity={3}
              currentStep={3}
            />
          )
        }
      </div>
      <Title title={apiType === 'admin' ? t('services.termsAndConditions') : t('services.termsAndConditions3')} />
      <TermsAndConditions
        onAccept={(checked: boolean) => {
          setCheckedTermsAndConditions(checked);
        }}
      />
      <Separator orientation='horizontal' />
      <div className='step-4-constancy__button-container'>
        <Button
          onClick={() => navigate(`/constancy-request/step_3/${params.constancyServiceID}/${params.requestNumber}/${params.clientID}/${params.collaboratorID}`)}
          type='primary'
          label={t('global.goBack') || ''}
          icon='leftArrow'
          iconPosition='left'
        />
        <Button
          onClick={updateConstancyService}
          type='primary'
          label={t('global.finish') || ''}
          icon='rightArrow'
          iconPosition='right'
        />
      </div>
    </div>
  );
};

export default Step4;
